import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonLayout from "../button/ButtonLayout";
import {
  CANCEL_LABEL,
  REMOVE_VALUE_LABEL,
  SELECT_LABEL,
} from "../../../utils/constants/GlobalConstants";
import TextInput from "../textInput/TextInput";
import Adornment from "../textInput/Adornment";
import SearchIcon from "@mui/icons-material/Search";
const POS_AB_RT_8 = {
  position: "absolute",
  right: 8,
  top: 8,
};
const MARGIN_PADD_02 = { m: 0, p: 2, borderBottom: "1px lightgray solid" };
const DialogView = (props) => {
const [value,setValue]=React.useState("");

  const handleAction = (e) => {
    props.handleAction(e);
    setValue("");
  }
  const handleChange=(e)=>{
  setValue(e.target.value);
  handleSearch(e.target.value);
  }
  const handleSearch=(value)=>{
    props.handleSearch(value);
  }
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(value)
    }
  };

  return (
    <Dialog
     testid="dialog"
      onClose={()=>{props.handleClose(); setValue("")}}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      style={{ zoom: 0.8 }}
      sx={props.style}
      PaperProps={{
        sx: {
          width: props.width ? props.width : "100%",
          maxWidth: props.maxWidth ? props.maxWidth : "65em!important",
          p: 0,
          m: 0,
          backgroundColor: props.background,
        },
      }}
    >
      <DialogTitle sx={MARGIN_PADD_02} id="customized-dialog-title">
        {props.heading}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={()=>{props.handleClose(); setValue("")}}
        sx={POS_AB_RT_8}
      >
        <CloseIcon />
      </IconButton>
      {props.from !== "parts" && <br />}
      {props.from !== "parts" && (
        <TextInput
          sx={{ width: "50%", marginLeft: "48%" }}
          label="Search..."
          testid="text"
          onChange={handleChange}
          value={value}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <Adornment>
                <SearchIcon testid="search" onClick={()=>{handleSearch(value)}} />
              </Adornment>
            ),
          }}
        />
      )}
      {props.from !== "parts" && <br />}
      <DialogContent dividers children={props.childComponet} />
      {props.from !== "parts" && (
        <DialogActions sx={{ my: 2 }}>
          <ButtonLayout disabled={!props.enableBtn} onClickBtn={()=>{ handleAction('select') }} color="primary" label={SELECT_LABEL} />
          <ButtonLayout testid="cancel" disabled={props.enableBtn} onClickBtn={ ()=>{ handleAction('cancel') }} color="primary" label={CANCEL_LABEL} />
          <ButtonLayout disabled={!props.enableBtn} onClickBtn={()=>{  handleAction('remove') }} color="primary" label={REMOVE_VALUE_LABEL} />
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogView;
